import {combinarFechasHora} from "../../Modulo_formularios/Funciones/combinarFechasHora";

export const obtenerProximoContacto = (contactos) => {


    if (!contactos) {
        return ''
    }

    const ahora = new Date();

    // 1. Filtramos los que están en el futuro y les calculamos su objeto Date
    const itemsFuturos = contactos
        .map(item => {
            // Asumimos formato de fecha 'YYYY-MM-DD' y hora 'HH:MM'
            // Esto crea un string que JavaScript puede parsear correctamente: 'YYYY-MM-DDTList:MM'
            const fechaObjeto = combinarFechasHora({fecha: item.fecha, fechaHora: item.hora})
            return {...item, _fechaObjeto: fechaObjeto};
        })
        .filter(item => item._fechaObjeto > ahora); // Solo nos quedamos con el futuro

    // 2. Si no hay eventos futuros, retornamos null
    if (itemsFuturos.length === 0) return '';

    // 3. Ordenamos de más cercano a más lejano
    itemsFuturos.sort((a, b) => a._fechaObjeto - b._fechaObjeto);

    // 4. Retornamos el primero de la lista (el más próximo), eliminando la propiedad temporal
    const {_fechaObjeto, ...elMasProximo} = itemsFuturos[0];
    return combinarFechasHora({fecha: elMasProximo.fecha, fechaHora: elMasProximo.hora});

}